@if ((cartDataReady$ | async) === false) {
  <div class="smp-page flex flex--column grow--min grey-25-bg ie--use-100vh">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
}

<div *ngIf="cartDataReady$ | async" class="smp-page flex flex--column grow--min ie--use-100vh grey-25-bg pr-small-b">
  <ng-container *ngIf="(showSeatPreSelection$ | async) !== true">
    <fin-booking-plain-header-area [title]="'phases.title.extras' | finLocalization"></fin-booking-plain-header-area>
    <p data-testid="points-prompt" *ngIf="(profileType$ | async) === ProfileType.FPLUS" class="font-body-1 ms-small-b">
      {{ 'ancillaries.payWithPoints' | finLocalization }}
    </p>
    @if (products$ | async) {
      <fin-booking-notification [isFullWidth]="false" [theme]="NotificationTheme.SUCCESS"></fin-booking-notification>
    }
    <div class="mobile-bleed flex-1">
      <fin-product-list
        [products$]="products$"
        [purchaseFlow]="purchaseFlow$ | async"
        [bounds$]="bounds$"
        [useNewProductCardLayout]="true"
        (selectProduct)="showSubview($event.category, $event.index)"
        (viewDetails)="viewDetails($event)"
        data-testid="product-list"
      ></fin-product-list>

      <fin-multi-city-survey class="block mr-small-y"></fin-multi-city-survey>

      <fin-ancillary-subview
        #ancillarySubview
        [showFlightCard$]="ancillarySubviewOpen$"
        [cartOrOrder$]="cart$"
        [subviewName]="'subview-' + (selectedCategory$ | async)"
        [boundsOrFlights]="boundsOrFlights$ | async"
        [locations]="locations$ | async"
        [titleKey]="buttonText[selectedCategory$ | async]?.title"
        [cartTotalPrice$]="totalPrice$"
        [category]="selectedCategory$ | async"
        [currentStep$]="currentStep$"
        [unpaidServices$]="unpaidServices$"
        [subviewContext]="TRACKING_CONTEXT"
        [boundOrFlightAncillaryAvailability$]="boundOrFlightAncillaryAvailability$"
        [passengersWithPetcIncompatibleSeats$]="passengersWithPetcIncompatibleSeats$"
        [confirmModalData$]="confirmModalData$"
        (closeConfirmModal)="closeConfirmModal($event)"
        (changeStep)="changeStep.emit($event)"
        (flightOrBoundSelected)="loadNextSeatMap($event)"
        (close)="updateCartServices(selectedCategory$.value)"
      >
        <ng-container *ngIf="selectedCategory$ | async as currentCategory">
          <ng-container *ngIf="BOUND_BASED_CATEGORIES.includes(currentCategory); else flights">
            <div *ngFor="let bound of bounds$ | async" class="inline-block valign-top fill">
              @if (currentCategory !== Category.PET) {
                <fin-common-product-selection
                  class="flex flex--column flex--nowrap"
                  [category$]="selectedCategory$"
                  [servicesReady$]="servicesReady$"
                  [travelers$]="travelers$"
                  [flightOrBound$]="bound | finToObservable"
                  [combinedServices$]="currentCombinedServices$"
                  [services$]="currentServices$ | finMap: bound.id"
                  [serviceQuantityMap$]="serviceQuantityMap$"
                  [paxLevelQuota$]="paxLevelQuota$"
                  [availability$]="boundOrFlightAncillaryAvailability$"
                  (subtotalChange)="ancillarySubview.setSubTotalPrice($event, currentCategory, bound.id)"
                ></fin-common-product-selection>
              }

              @if (currentCategory === Category.PET) {
                <fin-common-product-selection
                  class="flex flex--column flex--nowrap"
                  [category$]="selectedCategory$"
                  [servicesReady$]="servicesReady$"
                  [travelers$]="travelers$"
                  [flightOrBound$]="bound | finToObservable"
                  [combinedServices$]="currentCombinedServices$"
                  [services$]="servicesMap$ | finMap: currentCategory | finMap: bound.id"
                  (subtotalChange)="ancillarySubview.setSubTotalPrice($event, Category.PET, bound.id)"
                  [showConfirmationModalBeforeSelectionForPassengers$]="
                    passengersWithPetcIncompatibleSeats$ | finMap: bound.id
                  "
                  [confirmModalData$]="confirmModalData$"
                  (openConfirmModalWithData)="setConfirmModalData($event, PETC_CONFIRM_MODAL_TRANSLATION_KEYS)"
                  [availability$]="boundOrFlightAncillaryAvailability$"
                ></fin-common-product-selection>
              }
            </div>
          </ng-container>

          <ng-template #flights>
            <div *ngFor="let flight of flights$ | async" class="inline-block valign-top fill">
              <ng-container [ngSwitch]="currentCategory">
                @if (currentCategory === Category.SEAT) {
                  <fin-ancillary-seat-map
                    [flight]="flight"
                    [cartOrOrder$]="cart$"
                    [passengers$]="travelers$"
                    [seatSelections$]="seatSelections$"
                    [flightIsActive$]="activeFlight?.id === flight.id | finToObservable"
                    [availability$]="boundOrFlightAncillaryAvailability$"
                    [ancillaryLoader$]="ancillaryLoader$"
                    (changeSeats)="changeSeats($event)"
                    (subtotalChange)="ancillarySubview.setSubTotalPrice($event, Category.SEAT, flight.id)"
                  >
                  </fin-ancillary-seat-map>
                }

                @if ([Category.LOUNGE, Category.MEAL].includes(currentCategory)) {
                  <fin-common-product-selection
                    class="flex flex--column flex--nowrap"
                    [category$]="selectedCategory$"
                    [servicesReady$]="servicesReady$"
                    [travelers$]="travelers$"
                    [flightOrBound$]="flight | finToObservable"
                    [combinedServices$]="currentCombinedServices$"
                    [services$]="currentServices$ | finMap: flight.id"
                    [availability$]="boundOrFlightAncillaryAvailability$"
                    (subtotalChange)="ancillarySubview.setSubTotalPrice($event, currentCategory, flight.id)"
                  ></fin-common-product-selection>
                }

                @if (currentCategory === Category.WIFI) {
                  <fin-common-product-selection
                    class="flex flex--column flex--nowrap"
                    [category$]="selectedCategory$"
                    [servicesReady$]="servicesReady$"
                    [travelers$]="travelers$"
                    [flightOrBound$]="flight | finToObservable"
                    [combinedServices$]="currentCombinedServices$"
                    [services$]="currentServices$ | finMap: flight.id"
                    [availability$]="boundOrFlightAncillaryAvailability$"
                    [showConfirmationModalBeforeSelectionRemovalForPassengers$]="
                      passengersWithSeatWifiBundleSelected$ | finMap: flight.id
                    "
                    (subtotalChange)="ancillarySubview.setSubTotalPrice($event, currentCategory, flight.id)"
                    [confirmModalData$]="confirmModalData$"
                    (openConfirmModalWithData)="
                      setConfirmModalData($event, SEAT_WIFI_BUNDLE_REMOVAL_CONFIRM_MODAL_TRANSLATION_KEYS)
                    "
                  ></fin-common-product-selection>
                }
              </ng-container>
            </div>
          </ng-template>
        </ng-container>
      </fin-ancillary-subview>

      @if ((selectedCategory$ | async) !== Category.COVER) {
        <fin-ancillary-sidebar
          [category$]="selectedCategory$"
          [isSideBarOpen]="sideBarOpen"
          [boundsOrFlights$]="boundsOrFlights$"
          [locations]="locations$ | async"
          [passengers]="travelers$ | async"
          [availability$]="boundOrFlightAncillaryAvailability$"
          (changeSelectedIndex)="showSubview(selectedCategory$.value, $event)"
          (ctaSideBarClosed)="closeSidebar()"
          (sideBarClosed)="closeSidebar()"
        >
        </fin-ancillary-sidebar>
      }

      <fcom-cta-button
        data-testid="booking-ancillaries-travel-extras-continue-cta-button"
        [title]="'actions.next' | finLocalization"
        [visible]="showCtaButton$ | async"
        [position]="ButtonPosition.GRID"
        [disabled]="(hasTravelerInCart$ | async) === false"
        (buttonClicked)="continueToNextPhase.emit()"
      >
        <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
        <span *ngIf="totalPoints$ | async as points" class="font-body-1" data-testid="cta-points"
          >{{ 'award.points' | finLocalization: { pointsAmount: points || 0 | finPoints } }}&nbsp;+
        </span>
        <span data-testid="booking-ancillaries-travel-extras-continue-cta-button-price" class="font-body-1 bold-type">{{
          totalPrice$ | async | finPrice | finEmpty: '&ndash;'
        }}</span>
        <fcom-icon
          *ngIf="priceUpdating$ | async"
          [attr.aria-label]="'ctaButton.loading' | finLocalization"
          class="ms-xsmall-l icon-medium loading-icon"
          [name]="SvgLibraryIcon.TRANSFER_LOADER"
        ></fcom-icon>
      </fcom-cta-button>
    </div>
  </ng-container>
  @if ((showSeatPreSelection$ | async) === true) {
    <fin-seat-pre-selection
      [flights$]="flights$"
      [travelers$]="travelers$"
      [tripType$]="tripType$"
      [purchaseFlow$]="purchaseFlow$"
      [flightAncillaryAvailability$]="boundOrFlightAncillaryAvailability$"
      [cartOrOrder$]="cart$"
      [cartTotalPrice$]="totalPrice$"
      [passengersWithPetcIncompatibleSeats$]="passengersWithPetcIncompatibleSeats$"
      [combinedSeats]="currentCombinedServices$ | async"
      [locations]="locations$ | async"
      [seatSelections$]="seatSelections$"
      [selectionLoading$]="seatSelectionLoading$"
      (preSelectClosed)="closeSeatPreselection($event)"
      (flightSelected)="loadNextSeatMap($event)"
      (seatChanged)="changeSeats($event)"
    ></fin-seat-pre-selection>
  }
</div>
